import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import './Input.css';

export interface InputProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'onChange'
> {
  value: string;
  onChange: (val: string) => void;
  maxlength?: number;
}

const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { name, value, onChange, maxlength, ...rest },
  ref
) {
  const { className, ...restWithoutClassName } = rest;
  return (
    <input
      ref={ref}
      name={name}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      type="text"
      maxLength={maxlength}
      className={['Input', className].filter(Boolean).join(' ')}
      {...restWithoutClassName}
    />
  );
});

export default Input;
